export const defaultFlagStatus = {
  fileUpdate: false,
  folderUpdate: false,
  fileCreate: false,
  folderCreate: false,
};

export const HIDE_GIT_BASED_FOLDERS = ['rename', 'copy-webhook', 'delete-folder', 'move_folder'];
export const HIDE_GIT_BASED_FILES = [
  'rename',
  'duplicate_file',
  'copy_file',
  'move_file',
  'add_to_template',
  'add-document',
];
export const WORKSPACE_FILTER_TYPES = [
  { value: '', label: 'All Types' },
  { value: 'SERVICE', label: 'Service' },
  { value: 'TEAM', label: 'Team' },
  { value: 'PROJECT', label: 'Project' },
  { value: 'PRIVATE', label: 'Private' },
  { value: 'OTHERS', label: 'Others' },
];

export const defaultOptions = ['Factually incorrect', 'Off-topic', 'Too vague', 'Inappropriate', 'Other'];
